import React, {useEffect} from 'react';
import useGame from '../hooks/useGame';
import {FacebookShareButton, TwitterShareButton} from 'react-share';
import {useTranslation} from 'react-i18next';
import VideoFilesFullLoop from "./VideoFilesFullLoop";
import MobileVideoButton from './MobileVideoButton';
import { trackPageView } from '../helpers/gaHelper';

const End = () => {

  const {REACT_APP_SEB_URL, REACT_APP_SEB_URL_RU, REACT_APP_SHARE_TEXT, REACT_APP_UTM_END, PUBLIC_URL} = process.env;
  const {t} = useTranslation();
  const {totalScore, otherPlayers, resetGame, language, trackGTMEvent} = useGame();

  useEffect(() => {
    trackPageView('/completed');
  },[]);

  // attach the main.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/main.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // attach the jquery.nicescroll.min.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/jquery.nicescroll.min.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    trackGTMEvent('end');
  }, []);

  const openLink = (evt) => {
    if (evt?.keyCode === 13 || evt?.keyCode === 32) {
      window.open(evt.target.href);
    }
  }

  const removeBodyClass = className => document.body.classList.remove(className);

  const onPlayAgainClick = () => {
    removeBodyClass('fade-in-question');
    removeBodyClass('fade-out-video');
    resetGame()
  }

  return (
    <main>

      <MobileVideoButton className="final"/>
      <VideoFilesFullLoop page='end' id='end-video' showLoop={false} />

      <div role='button' tabIndex={0} id="skip-video" className="skip">
        <span className="current-time" id="sec" />
        {t('intro.skip_video')}
      </div>

      <section className="end">
        <div className="inner">
          <VideoFilesFullLoop page='end' id='end-video' showFull={false} />
          <div className="loop-screen final" />
          <h1>{t('end.your_score')}: <span id="score-num">{totalScore}</span></h1>
          <div className="sub">{t('end.scored_more_than')}</div>
          <div id="better-num">{otherPlayers}</div>
          <p>{(language === 'lv' && otherPlayers % 10 === 1) ? t('end.person') : t('end.people')}</p>
          <div className="bottom">
            <h2>{t('end.protect_money')}</h2>
            <button tabIndex={-1} className="default with-link"><a href={language === 'ru' ? REACT_APP_SEB_URL_RU+REACT_APP_UTM_END : REACT_APP_SEB_URL+REACT_APP_UTM_END} target="_blank" rel="noopener noreferrer"
              onKeyDown = {(evt) => openLink(evt)}
            >{t('end.click_here')}</a>
            </button>
            <div className="user-bottom">
              <a href="#" className="back-to-start" onClick={onPlayAgainClick}>{t('end.back_to_start')}</a>
              <span className="share">{t('end.share')} :</span>

              <FacebookShareButton url={window.location.href} quote={REACT_APP_SHARE_TEXT}>
                <span className="icon fb" />
              </FacebookShareButton>
              <TwitterShareButton url={window.location.href} title={REACT_APP_SHARE_TEXT}>
                <span className="icon tw" />
              </TwitterShareButton>

            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default End;
